import { immerable } from "immer";
import moment from "moment";

// Types
import type { TextMessage, TransferObject } from "src/types";

// Models
import FinishStatus from "./finish-status";
import PSTNCall from "./pstn-call";
import Uda from "./uda";

import { type DialerInstance } from "src/services/dialer";

export default class Call {
  [immerable] = true;

  // Vars
  id: string;
  aderenteSlug: string;
  aderenteName: string;
  aderenteResponsavelSlug: string;
  aderenteVertical: string[];
  features: Array<string>;
  createdAt: string;
  callType: string;
  finishStatuses: Array<FinishStatus>;
  finishStatus: string;
  waitingSupervisor: boolean;
  id_origem: string;

  uda: Uda;
  pstnNumbers: Array<PSTNCall>;

  // Call status
  isVideoEnabled: boolean;
  isAudioEnabled: boolean;
  isMicEnabled: boolean;
  transferenceStatus: TransferObject;

  // Text Messages
  messageList: Array<TextMessage>;
  messageListToText: Function;

  // Dialer instances
  dialerInstances?: Array<DialerInstance>;

  // Servico
  servico: {
    id: string;
    script_para_atendimento: string;
    script_apresentacao: string;
    script_encerramento: string;
    script_regras: string;
    script_sondagem: string;
    gif_sinal_empresa: string;
    gravar_ligacoes: boolean;
    fila: string;
  };

  constructor(options: any) {
    this.id = options.id;
    this.aderenteSlug = options.aderente_slug;
    this.aderenteName = options.aderente_nome;
    this.aderenteResponsavelSlug = options?.aderente_responsavel?.slug;
    this.aderenteVertical = options?.aderente_verticais_atuacao;
    this.features = options.features;
    this.createdAt = options.created_at;
    this.callType = options.tipo_canal;
    this.finishStatuses = options.finishStatuses;
    this.finishStatus = options.status_finalizador;
    this.waitingSupervisor = options.waitingSupervisor || false;
    this.id_origem = options.id_origem;

    // Call status
    this.transferenceStatus = options.transferenceStatus || {
      inTransference: false,
      isTransferenceOrigin: false,
    };

    // Uda Infos
    this.uda = new Uda(options.uda);

    // Servico
    this.servico = {
      id: options?.servico?.id,
      script_para_atendimento: options?.servico?.script_para_atendimento,
      script_apresentacao: options?.servico?.script_apresentacao,
      script_encerramento: options?.servico?.script_encerramento,
      script_regras: options?.servico?.script_regras,
      script_sondagem: options?.servico?.script_sondagem,
      gif_sinal_empresa: options?.servico?.gif_sinal_empresa,
      gravar_ligacoes: options?.servico?.gravar_ligacoes,
      fila: options?.servico?.fila,
    };

    // Dialer things
    this.dialerInstances = [];

    // Call numbers
    this.pstnNumbers = options?.pstnNumbers?.length
      ? options.pstnNumbers.map((number: string | PSTNCall) =>
          typeof number === "string"
            ? new PSTNCall({
                called: false,
                requestedNumber: number,
              })
            : number,
        )
      : [];

    // Pre load messages
    this.messageList = options?.messageList || [];

    // Controls
    this.isVideoEnabled = true;
    this.isAudioEnabled = true;
    this.isMicEnabled = true;

    // Helper functions
    this.messageListToText = function (lastMessage: TextMessage | null) {
      let webChatText = "";

      const exportMessages = [...this.messageList];

      if (lastMessage) exportMessages.push(lastMessage);

      exportMessages.forEach(function (key, val) {
        webChatText += `${moment(key.created_at).format("DD/MM/YYYY hh:mm:ss")} ${key.name} disse: ${key.text}\n`;
      });

      return webChatText;
    };
  }
}
